const REQUEST_APPOINTMENT_DETAILS_URL = '/request-appointment/enter-details'
const REQUEST_APPOINTMENT_BOOK_URL = '/request-appointment/book'
const REQUEST_APPOINTMENT_SUCCESS_URL = '/request-appointment/success'

export {
  REQUEST_APPOINTMENT_BOOK_URL,
  REQUEST_APPOINTMENT_SUCCESS_URL,
  REQUEST_APPOINTMENT_DETAILS_URL,
}
